import { journeyAction, } from './base';

import { JourneyActionVoiceSayPhonetic as JourneyActionVoiceSayPhoneticBase, } from 'atlas-shared';

export const JourneyActionVoiceSayPhonetic = journeyAction({
  ...JourneyActionVoiceSayPhoneticBase,
  icon: 'Voice',
});
